(function() {
    "use strict";

    let app = angular.module("app");

    app.service("request", service);

    service.$inject = ["$http", "auth"];

    function service($http, auth) {
        var wrapper = function() {

            // Apply global changes to arguments, or perform other
            // nefarious acts.

            return $http.apply($http, arguments);
        };

        // $http has convenience methods such as $http.get() that we have
        // to pass through as well.
        Object.keys($http).filter(function(key) {
            return (typeof $http[key] === 'function');
        }).forEach(function(key) {
            wrapper[key] = function() {
                if (key === 'get' || key === 'delete') {
                    if (arguments.length === 1) {
                        [].push.call(arguments, { headers: auth.headers() })
                    } else {
                        arguments[1].headers = { ...arguments[1].headers, ...auth.headers() }
                    }
                } else {
                    if (arguments.length === 1) {
                        [].push.call(arguments, {})
                    }
                    if (arguments.length === 2) {
                        [].push.call(arguments, { headers: auth.headers() })
                    } else {
                        arguments[2].headers = { ...arguments[2].headers, ...auth.headers() }
                    }
                }

                return $http[key].apply($http, arguments);
            };
        });

        return wrapper;
    }

})();
